import { userAvatarBucketName } from '@/config/env';
import { useMessageReadUsers } from '@/features/messages/queries/use-message-read-users';
import { GradientAvatar } from '@/shared/components';
import { AvatarGroup } from '@mui/material';
import type { Message } from '../../models/message';

interface MessageMenuSeenByProps {
  message: Message;
}

export const MessageMenuSeenBy = ({ message }: MessageMenuSeenByProps) => {
  const { data: readUsers } = useMessageReadUsers(message.conversationId!, message.messageId!);

  if (!readUsers || !readUsers.users || readUsers.users.length === 0) {
    return null;
  }

  return (
    <AvatarGroup max={3} sx={{ justifyContent: 'flex-start' }}>
      {readUsers.users.map((user) => (
        <GradientAvatar
          key={user.userId}
          peerId={user.userId}
          name={user.displayName}
          src={user.avatarUrl}
          bucketName={userAvatarBucketName}
          sx={{ width: 24, height: 24, fontSize: 12 }}
        />
      ))}
    </AvatarGroup>
  );
};
